<section>
	<div class="card">
		<div class="erro">
			<i class="far fa-sad-tear"></i>
			<h3>Um erro ocorreu a carregar as informações!</h3>
			<p>Pedimos desculpas pelo ocorrido, ja estamos tomando as devidas providências. <strong>Tente novamente mais tarde.</strong></p>
		</div>
	</div>
</section>
